module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HSLW6D.a900d7e9.jpg";